import { Outlet } from "react-router-dom";

export default function PageLayout() {
    return(
        <div>
            <Outlet />
        </div>
    )
};